<template>
  <div>
    <van-swipe
      class="swipe-material"
      :loop="false"
      :show-indicators="false"
      :width="230"
      @change="changeItem"
    >
      <van-swipe-item
        v-for="(item, index) in showData"
        :key="index"
        class="swipe-material-item"
      >
        <img
          class="img"
          v-if="item.type == '图片'"
          :src="item.img_url"
          alt=""
        />
        <div v-if="item.type == '视频'" class="video-box">
          <video
            :id="index"
            :poster="item.img_url || ''"
            muted="muted"
            x5-video-player-fullscreen="true"
            x5-video-orientation="portraint"
            webkit-playsinline=""
            x5-video-player-type="h5"
            preload=""
            loop="loop"
            playsinline=""
            class="video-item"
            :src="item.video_url"
            @click="stopVideo(index)"
          >
          </video>
          <img v-if="!videoStatus[index]" @click.stop="play(index)" class="playIcon" src="https://mktv-in-cdn.mockuai.com/16301394612256936.png" alt="">
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "tms-active-material",
  props: ["config", "isEditorStatus", "pageData"],
  data() {
    return {
      selectItem: 0,
      videoStatus:[],
    };
  },
  computed: {
    app_type() {
      return this.pageData.app_type || "seller";
    },
    property_data() {
      return this.config.property_data;
    },
    showData() {
      if (this.listData.length) {
        return this.listData;
      }
      return this.notData;
    },
    notData() {
      const obj = {
        type: "视频",
        img_url: "https://mktv-in-cdn.mockuai.com/16401554974227975.png",
        video_url: "https://mktv-in-cdn.mockuai.com/16303144103175329.mp4",
      };
      return [obj, obj, obj];
    },
    listData() {
      if (this.property_data.list && this.property_data.list.length) {
        return this.property_data.list;
      }
      return [];
    },
  },
  mounted() {
    this.lastRunTime = Date.now();
    this.page_id = this.$route.query.page_id;
    this.videoStatus = this.showData.map(()=>{return false});
  },
  methods: {
    changeItem(index) {
      if (this.selectItem != index) {
        this.stopVideo(this.selectItem * 1);
      }
    },
    stopVideo(index) {
      if (this.showData[this.selectItem * 1].type != "视频") {
        return;
      }
      let vdo = document.getElementById(index);
      if (!vdo.paused) {
        vdo.pause();
        this.$set(this.videoStatus, index, false);
      }
    },
    play(index) {
      try{
        let currentTime = Date.now();
        if(this.lastRunTime - currentTime > 100){
          return;
        }
        if (index != this.selectItem) {
          this.stopVideo(this.selectItem * 1);
        }
        this.selectItem = index;
        let vdo = document.getElementById(index);
        vdo.play();
        this.lastRunTime = Date.now();
        this.$set(this.videoStatus, index, true);
      }catch(err){

      }
    },
  },
};
</script>

<style lang="scss" scoped>
.swipe-material {
  margin: 0 0 8px 0;
}
.swipe-material-item {
  border-radius: 10px;
  overflow: hidden;
  height: 375px;
  .img {
    width: 220px;
    object-fit: cover;
    border-radius: 10px;
    margin-left: 10px;
  }
  .video-box {
    position: relative;
    .playIcon{
      position: absolute;
      z-index: 9999;
      top: 50%;
      left: 50%;
      width: 40px;
      height: 40px;
      margin-top: -20px;
      margin-left: -20px;
      
    }
  }
  .video-item {
    width: 220px;
    height: 375px;
    border-radius: 10px;
    object-fit: cover;
    overflow: hidden;
    margin-left: 10px;
    box-sizing: border-box;
  }
}
</style>
